// Business Optik TV Table Configuration

export const PLAN_NAMES = [
  'Basics (BTL)',
  'Core',
  'Choices',
  'More Choices',
  'Optik TV Basic',
  'Optik TV',
  'Optik TV Elite'
];

export const TERM_CONFIG = {
  'Month to Month': {
    prices: ['$25', '$40', '$63', '$83', '$30', '$65', '$85'],
    description: 'Monthly subscription with no contract commitment'
  },
  '36 Months': {
    prices: ['$25', '$30', '$55', '$68', '-', '-', '-'],
    description: '36-month contract with discounted rates'
  }
};

// Theme Packs Configuration
export const THEME_PACKS_LIST = [
  { name: 'Adrenaline', price: '$10.00' },
  { name: 'Arabic Pack', price: '$10.00' },
  { name: 'Blockbusters', price: '$10.00' },
  { name: 'Cantonese Culture', price: '$10.00' },
  { name: 'Carnet Monde', price: '$10.00' },
  { name: 'Disney Time', price: '$10.00' },
  { name: 'Explore', price: '$10.00' },
  { name: 'Family Time', price: '$10.00' },
  { name: 'Favourite Films', price: '$10.00' },
  { name: 'Hollywood Suite', price: '$10.00' },
  { name: 'IFC Films', price: '$6.00' },
  { name: 'Italian Pack', price: '$10.00' },
  { name: 'Jeunesse', price: '$10.00' },
  { name: 'Kids Time', price: '$10.00' },
  { name: 'Knowledge', price: '$10.00' },
  { name: 'Laughs & Cheers', price: '$10.00' },
  { name: 'Lifestyle & Beyond', price: '$10.00' },
  { name: 'Living', price: '$10.00' },
  { name: 'Mandarin Popular', price: '$10.00' },
  { name: 'Medley', price: '$10.00' },
  { name: 'Meli-melo', price: '$10.00' },
  { name: 'More News', price: '$10.00' },
  { name: 'More Sports', price: '$10.00' },
  { name: 'Nature & Civilization', price: '$10.00' },
  { name: 'News', price: '$10.00' },
  { name: 'Prime Time', price: '$10.00' },
  { name: 'Rural Outdoors', price: '$10.00' },
  { name: 'Shudder', price: '$6.00' },
  { name: 'South Asian Entertainment', price: '$10.00' },
  { name: 'South Asian Favourites', price: '$10.00' },
  { name: 'South Asian Movie Time', price: '$10.00' },
  { name: 'South Asian Zee Pack', price: '$10.00' },
  { name: 'Sports en francais', price: '$10.00' },
  { name: 'Sportsnet & Beyond', price: '$12.00' },
  { name: 'Sundance Now', price: '$7.00' },
  { name: 'Super Channel', price: '$10.00' },
  { name: 'Superstations', price: '$10.00' },
  { name: 'Time Shift', price: '$10.00' },
  { name: 'TSN & Beyond', price: '$12.00' },
  { name: 'Ukrainian Pack', price: '$10.00' },
  { name: 'Variety', price: '$10.00' },
  { name: 'World & Beyond', price: '$10.00' }
];

export const A_LA_CARTE_CHANNELS = [
  { name: '5 Kanal', price: '$7.00' },
  { name: 'A&E', price: '$5.00' },
  { name: 'Aapka Colors', price: '$10.00' },
  { name: 'ABC Spark', price: '$5.00' },
  { name: 'ABP News', price: '$7.00' },
  { name: 'Acorn TV', price: '$8.00' },
  { name: 'AddikTV', price: '$10.00' },
  { name: 'Adult Swim', price: '$5.00' },
  { name: 'Al Jazeera', price: '$5.00' },
  { name: 'AMC', price: '$5.00' },
  { name: 'CTV Wild', price: '$5.00' },
  { name: 'ATN', price: '$12.00' },
  { name: 'ATN B4U Movies', price: '$10.00' },
  { name: 'ATN B4U Music', price: '$7.00' },
  { name: 'ATN Max 2', price: '$10.00' },
  { name: 'ATN News', price: '$7.00' },
  { name: 'ATN Punjabi', price: '$7.00' },
  { name: 'ATN SAB TV', price: '$10.00' },
  { name: 'ATN SET Max', price: '$10.00' },
  { name: 'ATN Sony TV (Hindi)', price: '$10.00' },
  { name: 'ATN Star Bharat', price: '$7.00' },
  { name: 'ATN Times Now', price: '$7.00' },
  { name: 'ATN Urdu', price: '$7.00' },
  { name: 'ATN ZoOm', price: '$7.00' },
  { name: 'BabyTV (English)', price: '$5.00' },
  { name: 'BabyTV (French)', price: '$5.00' },
  { name: 'BabyTV (Mandarin)', price: '$7.00' },
  { name: 'BBC Earth HD', price: '$5.00' },
  { name: 'BBC First', price: '$5.00' },
  { name: 'BBC World News', price: '$5.00' },
  { name: 'beIN Sports', price: '$15.00' },
  { name: 'beIN Sports en Espanol', price: '$15.00' },
  { name: 'BNN Bloomberg', price: '$5.00' },
  { name: 'Canal D', price: '$7.00' },
  { name: 'Canal Evasion', price: '$7.00' },
  { name: 'Canal Vie', price: '$7.00' },
  { name: 'Cartoon Network', price: '$5.00' },
  { name: 'CBC News Network', price: '$4.00' },
  { name: 'CBN (English)', price: '$7.00' },
  { name: 'CCTV', price: '$7.00' },
  { name: 'Channel Y', price: '$7.00' },
  { name: 'CHRGD East', price: '$3.00' },
  { name: 'CHRGD West', price: '$3.00' },
  { name: 'CMT', price: '$5.00' },
  { name: 'CNBC', price: '$5.00' },
  { name: 'CNN', price: '$5.00' },
  { name: 'CNNi', price: '$5.00' },
  { name: 'Cooking Channel', price: '$5.00' },
  { name: 'Cottage Life', price: '$5.00' },
  { name: 'Crime + Investigation', price: '$5.00' },
  { name: 'CTV Comedy Channel', price: '$5.00' },
  { name: 'Bravo', price: '$5.00' },
  { name: 'CTV Life Channel', price: '$4.00' },
  { name: 'CTV News Channel HD', price: '$5.00' },
  { name: 'CTV Sci-Fi Channel', price: '$5.00' },
  { name: 'Daystar', price: '$3.00' },
  { name: 'DejaView', price: '$5.00' },
  { name: 'USA Network', price: '$5.00' },
  { name: 'Discovery Channel', price: '$5.00' },
  { name: 'CTV Nature', price: '$5.00' },
  { name: 'CTV Speed', price: '$5.00' },
  { name: 'Disney Channel', price: '$5.00' },
  { name: 'Disney Junior', price: '$5.00' },
  { name: 'Disney XD', price: '$5.00' },
  { name: 'DIY', price: '$5.00' },
  { name: 'Magnolia Network', price: '$5.00' },
  { name: 'Documentary', price: '$5.00' },
  { name: 'DTOUR', price: '$5.00' },
  { name: 'E!', price: '$5.00' },
  { name: 'Elle Fictions', price: '$3.00' },
  { name: 'ESPN Classic Sports', price: '$5.00' },
  { name: 'EuroNews', price: '$7.00' },
  { name: 'EuroNews (French)', price: '$7.00' },
  { name: 'Family Channel', price: '$5.00' },
  { name: 'Family Junior', price: '$5.00' },
  { name: 'Fight Network', price: '$5.00' },
  { name: 'Filipino TV (FTV)', price: '$7.00' },
  { name: 'First National', price: '$7.00' },
  { name: 'Flavour Network', price: '$5.00' },
  { name: 'Food Network', price: '$5.00' },
  { name: 'FOX News', price: '$5.00' },
  { name: 'FOX Sports Racing', price: '$5.00' },
  { name: 'Future Television', price: '$7.00' },
  { name: 'FX', price: '$5.00' },
  { name: 'Game TV', price: '$5.00' },
  { name: 'Game+', price: '$3.00' },
  { name: 'German Kino Plus', price: '$7.00' },
  { name: 'Global BC 1', price: '$5.00' },
  { name: 'GMA Life TV', price: '$7.00' },
  { name: 'Golf Channel', price: '$5.00' },
  { name: 'GSN', price: '$3.00' },
  { name: 'Halla Bol HD', price: '$7.00' },
  { name: 'Home Network', price: '$5.00' },
  { name: 'HGTV', price: '$7.00' },
  { name: 'Historia', price: '$5.00' },
  { name: 'History', price: '$5.00' },
  { name: 'HISTORY2', price: '$5.00' },
  { name: 'HLN', price: '$5.00' },
  { name: 'Hollywood Suite 2000s', price: '$5.00' },
  { name: 'Hollywood Suite 70s', price: '$5.00' },
  { name: 'Hollywood Suite 80s', price: '$5.00' },
  { name: 'Hollywood Suite 90s', price: '$5.00' },
  { name: 'ICI ARTV', price: '$3.00' },
  { name: 'ICI Explora', price: '$7.00' },
  { name: 'Oxygen', price: '$5.00' },
  { name: 'Investigation Discovery', price: '$5.00' },
  { name: 'Kapatid TV5', price: '$7.00' },
  { name: 'LCN', price: '$7.00' },
  { name: 'Lifetime', price: '$5.00' },
  { name: 'Love Nature', price: '$5.00' },
  { name: 'Makeful', price: '$5.00' },
  { name: 'Meteo-Media (French Weather Network)', price: '$3.00' },
  { name: 'Mezzo', price: '$5.00' },
  { name: 'Momo Kids', price: '$7.00' },
  { name: 'MovieTime', price: '$5.00' },
  { name: 'MSNBC', price: '$5.00' },
  { name: 'Much Music', price: '$4.00' },
  { name: 'Museum', price: '$5.00' },
  { name: 'Musimax', price: '$3.00' },
  { name: 'Nat Geo Wild', price: '$5.00' },
  { name: 'National Geographic', price: '$5.00' },
  { name: 'NBA TV Canada', price: '$5.00' },
  { name: 'Newfoundland Television (NTV)', price: '$5.00' },
  { name: 'NFL Network', price: '$5.00' },
  { name: 'Nickelodeon HD', price: '$5.00' },
  { name: 'ONE Get Fit', price: '$5.00' },
  { name: 'One Soccer', price: '$5.00' },
  { name: 'OUTtv', price: '$5.00' },
  { name: 'Peachtree TV', price: '$5.00' },
  { name: 'Phoenix North America', price: '$7.00' },
  { name: 'Planète+ ', price: '$7.00' },
  { name: 'PTC Punjabi', price: '$7.00' },
  { name: 'Rai Italia', price: '$7.00' },
  { name: 'RDS INFO', price: '$7.00' },
  { name: 'REV TV', price: '$4.00' },
  { name: 'Rewind', price: '$5.00' },
  { name: 'RFD TV', price: '$5.00' },
  { name: 'SANJHA TV', price: '$7.00' },
  { name: 'Series+', price: '$7.00' },
  { name: 'Showcase', price: '$5.00' },
  { name: 'Silver Screen Classics', price: '$5.00' },
  { name: 'Slice', price: '$5.00' },
  { name: 'Smithsonian Channel', price: '$5.00' },
  { name: 'Sportsman Canada', price: '$5.00' },
  { name: 'Sportsnet 360', price: '$7.00' },
  { name: 'Stingray Classica HD', price: '$7.00' },
  { name: 'Stingray Country', price: '$4.00' },
  { name: 'Stingray Loud', price: '$5.00' },
  { name: 'Stingray Retro', price: '$5.00' },
  { name: 'Stingray VIBE', price: '$5.00' },
  { name: 'T+E', price: '$5.00' },
  { name: 'Talentvision', price: '$11.00' },
  { name: 'TCM', price: '$5.00' },
  { name: 'Teletoon', price: '$5.00' },
  { name: 'Teletoon French', price: '$7.00' },
  { name: 'The Cowboy Channel', price: '$5.00' },
  { name: 'The Rural Channel', price: '$5.00' },
  { name: 'TLC', price: '$5.00' },
  { name: 'Today\'s Shopping Choice', price: '$3.00' },
  { name: 'Treehouse', price: '$5.00' },
  { name: 'Univision Canada HD', price: '$7.00' },
  { name: 'Vision TV', price: '$3.00' },
  { name: 'VRAK', price: '$7.00' },
  { name: 'W Network', price: '$5.00' },
  { name: 'Water', price: '$5.00' },
  { name: 'Wild', price: '$5.00' },
  { name: 'Willow Canada', price: '$7.00' },
  { name: 'WOW HDTV', price: '$3.00' },
  { name: 'QUB', price: '$7.00' },
  { name: 'YTV', price: '$4.00' },
  { name: 'Z', price: '$3.00' },
  { name: 'Zee Punjabi', price: '$7.00' },
  { name: 'Zee TV Canada', price: '$7.00' },
  { name: 'Zeste', price: '$7.00' },
  { name: 'Ztele', price: '$3.00' }
];

export const PREMIUM_CHANNELS = [
  { name: 'Crave', price: '$20.00' }
];

export const THEME_PACKS_CONFIG = {
  'Included Theme Packs': {
    type: 'multiselect',
    options: THEME_PACKS_LIST,
    showPrice: false,
    description: 'Theme packs included with selected plan'
  },
  'Additional Theme Packs (Additional Fee)': {
    type: 'multiselect', 
    options: THEME_PACKS_LIST,
    showPrice: true,
    description: 'Additional theme packs with monthly fees'
  },
  'A La Carte Channels (Additional Fee)': {
    type: 'multiselect',
    options: A_LA_CARTE_CHANNELS,
    showPrice: true,
    description: 'Individual channels with monthly fees'
  },
  'Premium Theme Packs': {
    type: 'multiselect',
    options: PREMIUM_CHANNELS,
    showPrice: true,
    description: 'Premium streaming services'
  }
};

export const ADD_ONS_CONFIG = {
  'Recordings / Cloud Personal Video Recorder (cPVR)': {
    type: 'checkbox',
    prices: ['$10.00', '$10.00', 'Included', 'Included', '-', '-', '-'],
    description: 'Cloud Personal Video Recorder service'
  }
};

export const PROMOTIONS_CONFIG = {
  '6 Month Promo': {
    type: 'checkbox',
    prices: ['-', '-', '-', '-', '-', '-$10.00', '-$10.00'],
    description: '6-month promotional discount'
  },
  '12 Month Promo': {
    type: 'checkbox', 
    prices: ['-', '-', '-', '-', '-', '-$10.00', '-$10.00'],
    description: '12-month promotional discount'
  }
};

export const SET_TOP_BOX_CONFIG = {
  'Wired': {
    type: 'counter',
    defaultValue: 1,
    min: 1,
    max: 5,
    description: 'Wired set top box units'
  },
  'Wireless': {
    type: 'counter',
    defaultValue: 0,
    min: 0,
    max: 5,
    description: 'Wireless set top box units'
  }
};

// Set Top Box pricing rules by plan type
export const SET_TOP_BOX_PRICING_RULES = {
  // Basics (BTL): mandatory first wired STB is $10/month
  BASICS_BTL: {
    plans: ['Basics (BTL)'],
    firstWiredStbPrice: 10, // Mandatory first wired STB is $10/month
    firstStbPrice: 10, // First wireless STB is $10
    additionalStbPrice: 10 // Each additional STB is $10
  },
  // TV Basic rate plans: $5 for each additional STB (first wired is free)
  TV_BASIC: {
    plans: ['Optik TV Basic'],
    firstWiredStbPrice: 0, // First wired STB is free
    firstStbPrice: 5, // First wireless STB is $5
    additionalStbPrice: 5 // Each additional STB is $5
  },
  // TV and TV Elite rate plans: each wireless STB is $5 (first wired is free)
  TV_ELITE: {
    plans: ['Optik TV', 'Optik TV Elite'],
    firstWiredStbPrice: 0, // First wired STB is free
    firstStbPrice: 5, // First wireless STB is $5
    additionalStbPrice: 5 // Each additional STB is $5
  },
  // Private/Home Based Business (OPUS) or Public (OPUS) or Public, Liquor Licensed (OPUS): $10 for each additional STB (first wired is free)
  OPUS: {
    plans: ['Private/Home Based Business (OPUS)', 'Public (OPUS)', 'Public, Liquor Licensed (OPUS)'],
    firstWiredStbPrice: 0, // First wired STB is free
    firstStbPrice: 10, // First wireless STB is $10
    additionalStbPrice: 10 // Each additional STB is $10
  },
  // Default pricing for other plans (first wired is free on 36-month; $10 on Month to Month)
  DEFAULT: {
    plans: ['Core', 'Choices', 'More Choices'],
    firstWiredStbPrice: 0, // First wired STB is free (36-month includes a free box)
    mtmFirstWiredStbPrice: 10, // Month to Month: mandatory first wired STB is $10
    firstStbPrice: 10, // First wireless STB is $10
    additionalStbPrice: 10 // Each additional STB is $10
  }
};

// Maximum total STBs allowed
export const MAX_TOTAL_STBS = 5;

export const INSTALLATION_CONFIG = {
  'Self Install (DIY)': {
    type: 'checkbox',
    prices: ['$0.00', '$0.00', '$0.00', '$0.00', '$0.00', '$0.00', '$0.00'],
    description: 'Self installation kit'
  },
  'Professional Install': {
    type: 'checkbox',
    prices: ['$99', '$99', '$99', '$99', '$99', '$99', '$99'],
    description: 'Professional installation service'
  },
  'Waived Professional Install (Multi Product Order)': {
    type: 'checkbox',
    prices: ['$0.00', '$0.00', '$0.00', '$0.00', '$0.00', '$0.00', '$0.00'],
    description: 'Free professional install for multi-product orders'
  },
  'Waived Professional Install (If moving from a competitor)': {
    type: 'checkbox',
    prices: ['$0.00', '$0.00', '$0.00', '$0.00', '$0.00', '$0.00', '$0.00'],
    description: 'Free professional install when switching from competitor'
  }
};

export const MONTHLY_CHARGES_CONFIG = {
  // To be implemented
};

export const ONE_TIME_CHARGES_CONFIG = {
  // To be implemented
};

// Profile type keys (match keys under vulcanWebform.businessOptikTv in EN/FR)
export const PROFILE_TYPE_KEYS = {
  PRIVATE_HOME_BASED_OPUS: 'privateHomeBasedBusinessOpus',
  PUBLIC_OPUS: 'publicOpus',
  PRIVATE_LEGACY: 'privateLegacy',
  PUBLIC_LEGACY: 'publicLegacy',
  PUBLIC_LIQUOR: 'publicLiquor'
};

// Translation keys for future French support
export const TRANSLATION_KEYS = {
  PLAN: 'plan',
  TERM: 'term',
  PROFILE_TYPE: 'profileType',
  INCLUDED_THEME_PACKS: 'includedThemePacks',
  ADDITIONAL_THEME_PACKS: 'additionalThemePacks',
  A_LA_CARTE_CHANNELS: 'aLaCarteChannels',
  PREMIUM_THEME_PACKS: 'premiumThemePacks',
  ADD_ONS: 'addOns',
  PROMOTIONS: 'promotions',
  SET_TOP_BOX: 'setTopBox',
  INSTALLATION: 'installation',
  RECORDINGS_CPVR: 'recordingsCpvr',
  SIX_MONTH_PROMO: 'sixMonthPromo',
  TWELVE_MONTH_PROMO: 'twelveMonthPromo',
  WIRED: 'wired',
  WIRELESS: 'wireless',
  SELF_INSTALL: 'selfInstall',
  PROFESSIONAL_INSTALL: 'professionalInstall',
  WAIVED_PROFESSIONAL_INSTALL_MULTI: 'waivedProfessionalInstallMulti',
  WAIVED_PROFESSIONAL_INSTALL_COMPETITOR: 'waivedProfessionalInstallCompetitor'
};

// Section configurations with translation keys
export const SECTION_CONFIG = {
  THEME_PACKS: {
    INCLUDED: {
      key: 'Included Theme Packs',
      translationKey: TRANSLATION_KEYS.INCLUDED_THEME_PACKS,
      type: 'multiselect',
      options: THEME_PACKS_LIST,
      showPrice: false
    },
    ADDITIONAL: {
      key: 'Additional Theme Packs (Additional Fee)',
      translationKey: TRANSLATION_KEYS.ADDITIONAL_THEME_PACKS,
      type: 'multiselect',
      options: THEME_PACKS_LIST,
      showPrice: true
    },
    A_LA_CARTE: {
      key: 'A La Carte Channels (Additional Fee)',
      translationKey: TRANSLATION_KEYS.A_LA_CARTE_CHANNELS,
      type: 'multiselect',
      options: A_LA_CARTE_CHANNELS,
      showPrice: true
    },
    PREMIUM: {
      key: 'Premium Theme Packs',
      translationKey: TRANSLATION_KEYS.PREMIUM_THEME_PACKS,
      type: 'multiselect',
      options: PREMIUM_CHANNELS,
      showPrice: true
    }
  },
  ADD_ONS: {
    RECORDINGS_CPVR: {
      key: 'Recordings / Cloud Personal Video Recorder (cPVR)',
      translationKey: TRANSLATION_KEYS.RECORDINGS_CPVR,
      type: 'checkbox',
      prices: ['$10.00', '$10.00', 'Included', 'Included', '-', '-', '-'],
      // Only show this add-on for these profile types (keys from vulcanWebform.businessOptikTv). Omit or empty = all profiles.
      allowedProfileTypes: [PROFILE_TYPE_KEYS.PRIVATE_HOME_BASED_OPUS]
    }
  },
  PROMOTIONS: {
    SIX_MONTH: {
      key: '6 Month Promo',
      translationKey: TRANSLATION_KEYS.SIX_MONTH_PROMO,
      type: 'checkbox',
      prices: ['-', '-', '-', '-', '-', '-$10.00', '-$10.00']
    },
    TWELVE_MONTH: {
      key: '12 Month Promo',
      translationKey: TRANSLATION_KEYS.TWELVE_MONTH_PROMO,
      type: 'checkbox',
      prices: ['-', '-', '-', '-', '-', '-$10.00', '-$10.00']
    }
  },
  SET_TOP_BOX: {
    WIRED: {
      key: 'Wired',
      translationKey: TRANSLATION_KEYS.WIRED,
      type: 'counter',
      defaultValue: 1,
      min: 1,
      max: 10
    },
    WIRELESS: {
      key: 'Wireless',
      translationKey: TRANSLATION_KEYS.WIRELESS,
      type: 'counter',
      defaultValue: 0,
      min: 0,
      max: 10
    }
  },
  INSTALLATION: {
    SELF_INSTALL: {
      key: 'Self Install (DIY)',
      translationKey: TRANSLATION_KEYS.SELF_INSTALL,
      type: 'checkbox',
      prices: ['$0.00', '$0.00', '$0.00', '$0.00', '$0.00', '$0.00', '$0.00']
    },
    PROFESSIONAL_INSTALL: {
      key: 'Professional Install',
      translationKey: TRANSLATION_KEYS.PROFESSIONAL_INSTALL,
      type: 'checkbox',
      prices: ['$99', '$99', '$99', '$99', '$99', '$99', '$99']
    },
    WAIVED_MULTI: {
      key: 'Waived Professional Install (Multi Product Order)',
      translationKey: TRANSLATION_KEYS.WAIVED_PROFESSIONAL_INSTALL_MULTI,
      type: 'checkbox',
      prices: ['$0.00', '$0.00', '$0.00', '$0.00', '$0.00', '$0.00', '$0.00']
    },
    WAIVED_COMPETITOR: {
      key: 'Waived Professional Install (If moving from a competitor)',
      translationKey: TRANSLATION_KEYS.WAIVED_PROFESSIONAL_INSTALL_COMPETITOR,
      type: 'checkbox',
      prices: ['$0.00', '$0.00', '$0.00', '$0.00', '$0.00', '$0.00', '$0.00']
    }
  }
};

// Helper function to get section keys for iteration
export const getThemePackSectionKeys = () => Object.values(SECTION_CONFIG.THEME_PACKS).map(section => section.key);
export const getAddOnSectionKeys = () => Object.values(SECTION_CONFIG.ADD_ONS).map(section => section.key);
export const getPromotionSectionKeys = () => Object.values(SECTION_CONFIG.PROMOTIONS).map(section => section.key);
export const getSetTopBoxSectionKeys = () => Object.values(SECTION_CONFIG.SET_TOP_BOX).map(section => section.key);
export const getInstallationSectionKeys = () => Object.values(SECTION_CONFIG.INSTALLATION).map(section => section.key);

export const getAddOnAllowedProfileTypeKeys = (addOnKey) => {
  const section = Object.values(SECTION_CONFIG.ADD_ONS).find(config => config.key === addOnKey);
  return section && section.allowedProfileTypes ? section.allowedProfileTypes : undefined;
};

export const isAddOnAvailableForProfile = (addOnKey, selectedProfileType, profileTypeTranslations) => {
  const allowedKeys = getAddOnAllowedProfileTypeKeys(addOnKey);
  if (!allowedKeys || allowedKeys.length === 0) return true;
  const allowedValues = allowedKeys.map(key => profileTypeTranslations[key]).filter(Boolean);
  return allowedValues.indexOf(selectedProfileType) !== -1;
};
